import { useState } from "react";
import { useNotificaciones } from "./NotificacionesContext";
import "./NotificacionesBell.css";

const IconBell = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
);

const getId = (notificacion) => notificacion?._id ?? notificacion?.id;

const formatearFecha = (valor) => {
    const fecha = new Date(valor);
    if (Number.isNaN(fecha.getTime())) return "";
    return fecha.toLocaleString("es-AR", {
        day: "numeric",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
    });
};

const NotificacionesBell = () => {
    const notificaciones = useNotificaciones();

    // Estado propio de la UI: que el panel este abierto y que pestaña se ve.
    const [abierto, setAbierto] = useState(false);
    const [tab, setTab] = useState("no-leidas");

    if (!notificaciones || !notificaciones.usuarioId) return null;

    const { noLeidas, leidas, cargando, error, cargarTodo, marcarLeida } = notificaciones;

    const cantidadNoLeidas = noLeidas.length;
    const lista = tab === "no-leidas" ? noLeidas : leidas;

    // Al abrir traemos ambas listas. Lo hacemos desde el handler (no desde un
    // useEffect) para no depender de la funcion en un array de dependencias.
    const alternarPanel = () => {
        const seVaAAbrir = !abierto;
        setAbierto(seVaAAbrir);
        if (seVaAAbrir) cargarTodo();
    };

    return (
        <>
            {/* Capa transparente: cualquier click afuera del panel lo cierra. */}
            {abierto && (
                <div className="notif-bell__backdrop" onClick={() => setAbierto(false)} />
            )}

            <div className="notif-bell">
                <button
                    type="button"
                    className="notif-bell__boton"
                    onClick={alternarPanel}
                    aria-label="Notificaciones"
                    aria-expanded={abierto}
                >
                    <IconBell />
                    {cantidadNoLeidas > 0 && (
                        <span className="notif-bell__badge">{cantidadNoLeidas > 9 ? "9+" : cantidadNoLeidas}</span>
                    )}
                </button>

                {abierto && (
                    <div className="notif-bell__panel" role="dialog" aria-label="Panel de notificaciones">
                        <div className="notif-bell__header">
                            <h3>Notificaciones</h3>
                            <div className="notif-bell__tabs">
                                <button
                                    className={`notif-bell__tab${tab === "no-leidas" ? " notif-bell__tab--activa" : ""}`}
                                    onClick={() => setTab("no-leidas")}
                                >
                                    No leídas {cantidadNoLeidas > 0 && `(${cantidadNoLeidas})`}
                                </button>
                                <button
                                    className={`notif-bell__tab${tab === "leidas" ? " notif-bell__tab--activa" : ""}`}
                                    onClick={() => setTab("leidas")}
                                >
                                    Leídas
                                </button>
                            </div>
                        </div>

                        <div className="notif-bell__lista">
                            {cargando ? (
                                <div className="notif-bell__estado">
                                    <div className="notif-bell__loader" />
                                    <span>Cargando...</span>
                                </div>
                            ) : error ? (
                                <div className="notif-bell__estado notif-bell__estado--error">{error}</div>
                            ) : lista.length === 0 ? (
                                <div className="notif-bell__estado">
                                    {tab === "no-leidas" ? "No tenés notificaciones sin leer." : "No hay notificaciones leídas."}
                                </div>
                            ) : (
                                lista.map((n) => (
                                    <div
                                        key={getId(n)}
                                        className={`notif-bell__item${n.leida ? " notif-bell__item--leida" : ""}`}
                                    >
                                        <p className="notif-bell__mensaje">{n.mensaje}</p>
                                        <div className="notif-bell__pie">
                                            <span className="notif-bell__fecha">{formatearFecha(n.horaEntrega ?? n.createdAt)}</span>
                                            {!n.leida && (
                                                <button
                                                    className="notif-bell__marcar"
                                                    onClick={() => marcarLeida(getId(n))}
                                                >
                                                    Marcar como leída
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default NotificacionesBell;
